import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ChatFeedback,
  ChatFile,
  ChatRequest,
  ChatResponse,
  ConversationDetail,
  FeedbackRequest,
  SessionSummary,
} from '../_models';

const ASK_SOLVPATH_HEADERS = { ask_solvpath_api: 'true' };

@Injectable()
export class AskSolvpathService {
  constructor(protected http: HttpClient) {}

  private get<T>(url: string): Observable<T> {
    return this.http.get<T>(url, { headers: ASK_SOLVPATH_HEADERS });
  }

  private post<T>(url: string, body: any): Observable<T> {
    return this.http.post<T>(url, body, { headers: ASK_SOLVPATH_HEADERS });
  }

  private delete<T>(url: string): Observable<T> {
    return this.http.delete<T>(url, { headers: ASK_SOLVPATH_HEADERS });
  }

  checkHealth(): Observable<any> {
    return this.get('v1/health');
  }

  getIdentity(): Observable<any> {
    return this.get('v1/auth/me');
  }

  sendMessage(question: string, conversationId: string | null): Observable<ChatResponse> {
    const body: ChatRequest = { question, history: [], conversation_id: conversationId };

    return this.post<ChatResponse>('v1/chats', body);
  }

  submitFeedback(turnId: string, feedback: ChatFeedback): Observable<any> {
    const body: FeedbackRequest = { conversation_id: turnId, rating: feedback };

    return this.post('v1/feedback', body);
  }

  endConversation(conversationId: string): Observable<any> {
    return this.post(`v1/conversations/${conversationId}/end`, {});
  }

  createConversation(): Observable<SessionSummary> {
    return this.post<SessionSummary>('v1/conversations', { title: null });
  }

  listConversations(limit: number = 20): Observable<{ items: SessionSummary[] }> {
    return this.get<{ items: SessionSummary[] }>(`v1/conversations?archived=false&limit=${limit}&offset=0`);
  }

  getConversation(conversationId: string): Observable<ConversationDetail> {
    return this.get<ConversationDetail>(`v1/conversations/${conversationId}`);
  }

  deleteConversation(conversationId: string): Observable<any> {
    return this.delete(`v1/conversations/${conversationId}`);
  }

  uploadFile(conversationId: string, file: File): Observable<ChatFile> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.post<ChatFile>(`v1/chats/${conversationId}/files`, formData);
  }

  listFiles(conversationId: string): Observable<{ items: ChatFile[] }> {
    return this.get<{ items: ChatFile[] }>(`v1/chats/${conversationId}/files`);
  }

  detachFile(conversationId: string, fileId: string): Observable<any> {
    return this.delete(`v1/chats/${conversationId}/files/${fileId}`);
  }
}
